export class TextTemplates {

    static textStyleTemplates = [
        {
            id: 0,
            box: { show: true, color: "#ffffff" },
            color: "#000000",
            font: { name: "Roboto, sans-serif", title: "Roboto" },
            fontWeight: "normal",
            height: { name: "30px", title: "30 px", value: 30 },
            opacity: 1,
            size: { name: "25px", title: "25 px", value: 25 },
            value: "Text Example",
        },
        {
            id: 1,
            box: { show: true, color: "#3f3f3f" },
            color: "#ffffff",
            font: { name: "Roboto, sans-serif", title: "Roboto" },
            fontWeight: "normal",
            height: { name: "30px", title: "30 px", value: 30 },
            opacity: 1,
            size: { name: "25px", title: "25 px", value: 25 },
            value: "Text Example",
        },
        {
            id: 2,
            box: { show: true, color: "#ffffff" },
            color: "#000000",
            font: { name: "Roboto, sans-serif", title: "Roboto" },
            fontWeight: "normal",
            height: { name: "30px", title: "30 px", value: 30 },
            opacity: 0,
            size: { name: "25px", title: "25 px", value: 25 },
            value: "Text Example",
        },
        {
            id: 3,
            box: { show: true, color: "#000000" },
            color: "#ffffff",
            font: { name: "Roboto, sans-serif", title: "Roboto" },
            fontWeight: "normal",
            height: { name: "30px", title: "30 px", value: 30 },
            opacity: 0,
            size: { name: "25px", title: "25 px", value: 25 },
            value: "Text Example",
        },
        {
            id: 4,
            isRectangle: true,
            box: { show: true, color: "#ffffff", width: 15 },
            color: "#000000",
            font: { name: "Roboto, sans-serif", title: "Roboto" },
            fontWeight: "normal",
            height: { name: "30px", title: "30 px", value: 30 },
            opacity: 1,
            size: { name: "25px", title: "25 px", value: 25 },
            value: "Multi-Language",
            width: "100%",
        },
    ];
}